import { useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../../services/api'
import ReproductorFormacion from '../formacion/ReproductorFormacion'
import { Ico } from '../ui'
import { t } from '../../utils/i18n'

// ══════════════════════════════════════════════════════════════════════════════════════════════
//  t591 · B-2432 · EL VÍDEO DE LA FORMACIÓN DENTRO DEL PANEL DE LucIA (31-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//  El dueño (30-oct): «el asistente lucia debe poder usar y adjuntar estos videos en las conversaciones». A «¿cómo se da una cita?»
//  LucIA contesta con el centro de ayuda y, si la Formación tiene el vídeo de eso, lo ADJUNTA: el servidor lo manda como una tarjeta
//  (backend/services/asistenteLuciaHerramientas · buscar_ayuda, `{ tipo: 'video_formacion', num }`, elegido por
//  services/asistenteLuciaFormacion y solo a quien puede ver la Formación) y aquí se pinta con el MISMO reproductor que la Formación,
//  el chat de ayuda y «Cómo se hace» (components/formacion/ReproductorFormacion): enlace firmado de pocos minutos, la marca de agua,
//  los CAPÍTULOS y el punto donde lo dejó (GET /formacion/lecciones/:num, la misma consulta que la lección y que «Cómo se hace») y la
//  lección vista al acabarlo. Debajo, «Ver la lección completa en la Formación».
//  Sin las condiciones de la Formación aceptadas (403 FORMACION_CONDICIONES), se dice que primero hay que aceptarlas; con la Formación
//  cerrada para esa persona (FORMACION_CERRADA), su aviso en llano, nunca una caja negra.
export default function TarjetaVideoFormacion({ t: v, onEnlace }) {
  const qc = useQueryClient()
  const num = Number(v && (v.num || v.id))
  const { data: det, isLoading, error } = useQuery({
    queryKey: ['formacion-leccion', String(num)],
    queryFn: () => api.get('/formacion/lecciones/' + num).then(r => r.data),
    enabled: Number.isInteger(num) && num > 0, retry: false, staleTime: 60 * 1000,
  })
  if (!Number.isInteger(num) || num <= 0) return null
  const cuerpo = (error && error.response && error.response.data) || {}
  const condiciones = !!error && cuerpo.codigo === 'FORMACION_CONDICIONES'
  const cerrada = !!error && !condiciones && error.response && error.response.status === 403
  const capitulos = (det && det.leccion && Array.isArray(det.leccion.capitulos)) ? det.leccion.capitulos : []
  const alVer = () => {
    qc.invalidateQueries({ queryKey: ['formacion-catalogo'] })
    qc.invalidateQueries({ queryKey: ['formacion-resumen'] })
    qc.invalidateQueries({ queryKey: ['formacion-leccion', String(num)] })
  }
  const ruta = v.ruta || ('/formacion/' + num)
  return (
    <div data-asistente-video-formacion={num}
      style={{ border: '1px solid var(--border)', borderRadius: '12px', background: 'var(--surface)', padding: '10px 12px', minWidth: 0 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '11.5px', fontWeight: 800, letterSpacing: '.04em', textTransform: 'uppercase', color: 'var(--primary-tinta, var(--primary))', marginBottom: '2px' }}>
        <Ico n="birrete" s={14} /> {t('components.asistenteLucia.TarjetaVideoFormacion.mira_como_se_hace', 'Mira cómo se hace')}
      </div>
      <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--text-primary)', marginBottom: '8px' }}>
        {v.titulo}{v.duracion ? <span style={{ color: 'var(--text-muted)', fontWeight: 600 }}> · {v.duracion}</span> : null}
      </div>
      {condiciones ? (
        <div role="status" data-asistente-video-condiciones="" style={{ fontSize: '12.5px', lineHeight: 1.5, color: 'var(--text-secondary)' }}>
          {t('components.asistenteLucia.TarjetaVideoFormacion.condiciones', 'Antes del primer vídeo, acepta las condiciones de la Formación (se hace una sola vez).')}
        </div>
      ) : cerrada ? (
        <div role="status" data-asistente-video-cerrada="" style={{ fontSize: '12.5px', lineHeight: 1.5, color: 'var(--text-secondary)' }}>
          {cuerpo.error || t('components.asistenteLucia.TarjetaVideoFormacion.cerrada', 'Ahora mismo no puedes ver los vídeos de la Formación.')}
        </div>
      ) : isLoading ? (
        <div aria-hidden="true" style={{ width: '100%', aspectRatio: '16 / 9', borderRadius: '10px', background: '#000' }} />
      ) : (
        <ReproductorFormacion key={num} num={num} duracionSeg={Number(v.duracion_seg) || 0} capitulos={capitulos}
          posicionInicial={(det && Number(det.posicion_seg)) || 0} onVista={alVer} compacto />
      )}
      <a href={condiciones ? '/formacion' : ruta} data-asistente-video-leccion="" onClick={(e) => { e.preventDefault(); if (onEnlace) onEnlace(condiciones ? '/formacion' : ruta) }}
        style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', marginTop: '8px', color: 'var(--primary)', fontWeight: 700, fontSize: '12.5px' }}>
        {condiciones
          ? t('components.asistenteLucia.TarjetaVideoFormacion.abrir_formacion', 'Abrir la Formación')
          : t('components.asistenteLucia.TarjetaVideoFormacion.leccion_completa', 'Ver la lección completa en la Formación')} <Ico n="chevronR" s={13} />
      </a>
    </div>
  )
}
